// Utility to create a histogram (value → count) from an array of numbers
export function histogram(values: (number | null | undefined)[]): { value: number, count: number }[] {
  const counts = new Map<number, number>();
  for (const v of values) {
    if (typeof v === 'number' && !isNaN(v)) {
      counts.set(v, (counts.get(v) ?? 0) + 1);
    }
  }
  return Array.from(counts.entries())
    .map(([value, count]) => ({ value, count }))
    .sort((a, b) => a.value - b.value);
}
